module.exports = __webpack_public_path__ + "img/allstar_en.7efc7fe.jpg";